import {InboxAttachment, Signable} from './inbox-attachment';

export enum InboxMessageStatus {
  READ = 'READ',
  UNREAD = 'UNREAD'
}

export class InboxMessage {

  niss: string;
  status: InboxMessageStatus;
  active: Signable;
  // ISO "yyyy-MM-dd" string on the wire; consumers wrap it in new Date() themselves
  datePosted: string;
  attachments?: InboxAttachment[];
  comment?: string;
  description?: string;
  id?: string;

  constructor(niss: string,
              status: InboxMessageStatus,
              active: Signable,
              datePosted: string,
              attachments?: InboxAttachment[],
              comment?: string,
              description?: string,
              id?: string) {
    this.niss = niss;
    this.status = status;
    this.active = active;
    this.datePosted = datePosted;
    this.attachments = attachments;
    this.comment = comment;
    this.description = description;
    this.id = id;
  }
}
